// ─── Salary Advance API Constants ────────────────────────────────────────────

export const RQ_GET_ALL_SALARY_ADVANCE_API = {
  url:    'api/salary-advance/lookupAll',
  method: 'GET',
  auth:   true,
};

export const RQ_GET_SALARY_ADVANCE_BY_EMPLOYEE_ID_API = {
  url:    'api/salary-advance/lookupBy/<%= employeeId %>',
  method: 'GET',
  auth:   true,
};

export const RQ_ADD_SALARY_ADVANCE_API = {
  url:    'api/salary-advance/add',
  method: 'POST',
  auth:   true,
};

export const RQ_UPDATE_SALARY_ADVANCE_API = {
  url:    'api/salary-advance/update/<%= id %>',
  method: 'PUT',
  auth:   true,
};

export const RQ_DELETE_SALARY_ADVANCE_API = {
  url:    'api/salary-advance/delete/<%= id %>',
  method: 'DELETE',
  auth:   true,
};

// ─── Salary API Constants ─────────────────────────────────────────────────────

/**
 * POST /api/salary/generateByDateRange/{employeeId}
 * Query params: fromDate, toDate, survivalAmount
 */
export const RQ_GENERATE_SALARY_BY_DATE_RANGE_API = {
  url:    'api/salary/generateByDateRange/<%= employeeId %>',
  method: 'POST',
  auth:   true,
};

/**
 * POST /api/salary/generateByDateRange/all
 * Query params: fromDate, toDate
 */
export const RQ_GENERATE_SALARY_ALL_BY_DATE_RANGE_API = {
  url:    'api/salary/generateByDateRange/all',
  method: 'POST',
  auth:   true,
};

/**
 * GET /api/salary/lookupByDateRange/{employeeId}
 * Query params: fromDate, toDate
 */
export const RQ_LOOKUP_SALARY_BY_DATE_RANGE_API = {
  url:    'api/salary/lookupByDateRange/<%= employeeId %>',
  method: 'GET',
  auth:   true,
};

/**
 * GET /api/salary/lookupBy/{employeeId}
 */
export const RQ_LOOKUP_SALARY_BY_EMPLOYEE_ID_API = {
  url:    'api/salary/lookupBy/<%= employeeId %>',
  method: 'GET',
  auth:   true,
};

/**
 * GET /api/salary/lookupAll
 */
export const RQ_LOOKUP_ALL_SALARY_API = {
  url:    'api/salary/lookup/all',
  method: 'GET',
  auth:   true,
};

/**
 * GET /api/salary/lookupAllByDateRange
 * Query params: fromDate, toDate
 */
export const RQ_LOOKUP_ALL_SALARY_BY_DATE_RANGE_API = {
  url:    'api/salary/lookupAllByDateRange',
  method: 'GET',
  auth:   true,
};

/**
 * GET /api/salary/api/get/generated/{employeeId}
 * Query params: month, year
 */
export const RQ_GET_GENERATED_SALARY_BY_EMPLOYEE_ID_API = {
  url:    'api/salary/api/get/generated/<%= employeeId %>',
  method: 'GET',
  auth:   true,
};

export const RQ_SALARY_DELETE_API = {
  url:    'api/salary/delete/<%= salaryId %>',
  method: 'DELETE',
  auth:   true,
};
